import { Link } from 'react-router-dom'
import '../styles/StaticPages.css'

function ComingSoon({ title, description }) {
  return (
    <div className="static-page coming-soon">
      <nav className="static-nav">
        <Link to="/" className="nav-logo">
          <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="url(#logo-grad)"/>
            <path d="M12 20h16M20 12v16" stroke="white" strokeWidth="3" strokeLinecap="round"/>
            <defs>
              <linearGradient id="logo-grad" x1="0" y1="0" x2="40" y2="40">
                <stop stopColor="#7C3AED"/>
                <stop offset="1" stopColor="#2563EB"/>
              </linearGradient>
            </defs>
          </svg>
          <span>Hubthrill</span>
        </Link>
        <div className="nav-actions">
          <Link to="/login" className="btn btn-secondary">Log in</Link>
          <Link to="/signup" className="btn btn-primary">Get started</Link>
        </div>
      </nav>

      <div className="coming-soon-content">
        <div className="badge">Coming Soon</div>
        <h1>{title}</h1>
        <p>{description}</p>
        
        <form className="notify-form">
          <input type="email" placeholder="Enter your email" />
          <button type="submit" className="btn btn-primary">Notify me</button>
        </form>

        <Link to="/" className="back-link">← Back to homepage</Link>
      </div>
    </div>
  )
}

export function Pricing() {
  return (
    <ComingSoon 
      title="Pricing" 
      description="Simple, transparent pricing for businesses of all sizes. Pay for what you use, cancel anytime."
    />
  )
}

export function Docs() {
  return (
    <ComingSoon 
      title="Documentation" 
      description="Comprehensive guides, API references, and tutorials to help you get the most out of Hubthrill."
    />
  )
}

export function Company() {
  return (
    <ComingSoon 
      title="About Hubthrill" 
      description="Learn about our mission to simplify business operations and the team behind Hubthrill."
    />
  )
}

export function Demo() {
  return (
    <ComingSoon 
      title="Request a Demo" 
      description="See Hubthrill in action. Our team will walk you through the platform and answer your questions."
    />
  )
}

export function Contact() {
  return (
    <ComingSoon 
      title="Contact Us" 
      description="Get in touch with our sales team or support. We're here to help."
    />
  )
}

export function Support() {
  return (
    <ComingSoon 
      title="Support Center" 
      description="Find answers, submit tickets, and get help from our support team."
    />
  )
}

export function Terms() {
  return (
    <div className="static-page legal-page">
      <nav className="static-nav">
        <Link to="/" className="nav-logo">
          <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="url(#logo-grad-terms)"/>
            <path d="M12 20h16M20 12v16" stroke="white" strokeWidth="3" strokeLinecap="round"/>
            <defs>
              <linearGradient id="logo-grad-terms" x1="0" y1="0" x2="40" y2="40">
                <stop stopColor="#7C3AED"/>
                <stop offset="1" stopColor="#2563EB"/>
              </linearGradient>
            </defs>
          </svg>
          <span>Hubthrill</span>
        </Link>
      </nav>

      <div className="legal-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: February 9, 2026</p>
        
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using Hubthrill's services, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>Hubthrill provides a unified business platform including website building (Studio), payments (Chekkouts), accounting (Keeply), customer support (Relay), HR management (People), and infrastructure (Namelyft).</p>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
        </section>

        <section>
          <h2>4. Payment Terms</h2>
          <p>Certain features require payment. You agree to pay all fees associated with your chosen plan. Fees are non-refundable except as required by law.</p>
        </section>

        <section>
          <h2>5. Privacy</h2>
          <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect and use your information.</p>
        </section>

        <section>
          <h2>6. Contact</h2>
          <p>For questions about these Terms, contact us at legal@hubthrill.com</p>
        </section>

        <Link to="/" className="back-link">← Back to homepage</Link>
      </div>
    </div>
  )
}

export function Privacy() {
  return (
    <div className="static-page legal-page">
      <nav className="static-nav">
        <Link to="/" className="nav-logo">
          <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="url(#logo-grad-privacy)"/>
            <path d="M12 20h16M20 12v16" stroke="white" strokeWidth="3" strokeLinecap="round"/>
            <defs>
              <linearGradient id="logo-grad-privacy" x1="0" y1="0" x2="40" y2="40">
                <stop stopColor="#7C3AED"/>
                <stop offset="1" stopColor="#2563EB"/>
              </linearGradient>
            </defs>
          </svg>
          <span>Hubthrill</span>
        </Link>
      </nav>

      <div className="legal-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: February 9, 2026</p>
        
        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly, such as account details, payment information, and communications with us.</p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to provide and improve our services, process transactions, and communicate with you.</p>
        </section>

        <section>
          <h2>3. Data Security</h2>
          <p>We implement industry-standard security measures including encryption, access controls, and regular security audits.</p>
        </section>

        <section>
          <h2>4. Data Retention</h2>
          <p>We retain your data for as long as your account is active or as needed to provide services and comply with legal obligations.</p>
        </section>

        <section>
          <h2>5. Your Rights</h2>
          <p>You have the right to access, correct, or delete your personal data. Contact privacy@hubthrill.com to exercise these rights.</p>
        </section>

        <section>
          <h2>6. Contact</h2>
          <p>For privacy-related questions, contact us at privacy@hubthrill.com</p>
        </section>

        <Link to="/" className="back-link">← Back to homepage</Link>
      </div>
    </div>
  )
}

export default ComingSoon
